import { styled } from '@mui/material/styles';
import { TitlePart } from '@bloomays-lib/ui.shared';
import { useTranslation } from 'react-i18next';
import hourglass from '../../graphic-charter/illustrations/hourglass.png';

const PrimesAnnualPage = () => {
  const { t } = useTranslation(['primes']);

  return (
    <ComingSoonContainer>
      <Image src={hourglass} alt="" />
      <TitlePart textTitle={t('comingSoon')} />
    </ComingSoonContainer>
  );
};

export default PrimesAnnualPage;

const ComingSoonContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2.5),
}));

const Image = styled('img')(() => ({
  maxWidth: '280px',
  width: '100%',
  height: 'auto',
}));
